<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.projectNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.name"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @add="addFun(arguments)"
        />
      </div>

      <!-- 新增 -->
      <add-edit-dialog
        :event-type="'add'"
        :send-object="dataObject"
        :dialog-title="dialogAddTitle"
        :dialog-visible.sync="dialogAddVisible"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 新增
import addEditDialog from './addEditDialog'
// 方案API
import { loadSchemeListDataApi } from '@/api/v2/scheme';

export default {
  name: 'MaterialsSchemeTodoReceivableList',
  components: { CustomTable2, addEditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_scheme_todo_receivable_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建应收款单',
            method: 'add'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          projectNo: '',
          name: '',
          todoReceivable: 'true'
        }
      },
      isPaging: true,
      dialogAddTitle: '',
      dialogAddVisible: false,
      dataObject: {}
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.multipleSelection = []
        _this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'provinceNames', label: '省区', filterColumn: 'province_names', width: 90 },
          { prop: 'cityNames', label: '市场', filterColumn: 'city_names', width: 100 },
          { prop: 'executeStatusValue', label: '痕迹化进度', filterColumn: 'execute_status', filterValue: 'executeStatus', filterArray: [{ label: '无', value: 0 }, { label: '进度不监控', value: 1 }, { label: '收取资料', value: 2 }, { label: '资料检查', value: 3 }, { label: '提交分中心', value: 4 }, { label: '分中心验收中', value: 5 }, { label: '验收通过', value: 6 }], width: 140 },
          { prop: 'projectNo', label: '方案编号', filterColumn: 'project_no', width: 200 },
          { prop: 'name', label: '方案名称', width: 300 },
          { prop: 'schemeAmount', label: '方案金额', filterColumn: 'scheme_amount', width: 150, formatPrice: true },
          { prop: 'reportDate', label: '填报时间', filterColumn: 'report_date', width: 120, isBetween: true },
          { prop: 'schemeTypeValue', label: '方案类型', filterColumn: 'scheme_type', filterValue: 'schemeType', filterArray: [{ label: '合同一(终端运维)', value: 3 }, { label: '合同二(品牌推广)', value: 4 }, { label: '其他', value: 5 }], width: 110 },
          { prop: 'startDate', label: '开始时间', filterColumn: 'start_date', width: 150, isBetween: true },
          { prop: 'endDate', label: '结束时间', filterColumn: 'end_date', width: 150, isBetween: true },
          { prop: 'schemeContent', label: '方案内容', filterColumn: 'scheme_content', width: 300 },
          { prop: 'executivePersonnel', label: '执行人', filterColumn: 'executive_personnel', width: 110 },
          { prop: 'schemeStatusValue', label: '执行状态', filterColumn: 'schemeStatus', filterValue: 'schemeStatus', filterArray: [{ label: '执行中', value: 1 }, { label: '执行完成', value: 2 }, { label: '终止执行', value: 3 }], width: 110 },
          { prop: 'isTrulySettleValue', label: '据实结算', filterColumn: 'is_truly_settle', filterValue: 'isTrulySettle', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 110 },
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.sortOrder = ''
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSchemeListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false)
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建应收款单
    addFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要创建应收款单的方案', type: 'warning' })
        return
      } else if (args[0].executeStatus !== 1 && args[0].executeStatus !== 6) {
        _this.$message({ message: '方案痕迹化资料未验收通过，不能创建应收单', type: 'warning' })
        return
      }
      _this.dataObject = args[0]
      _this.dialogAddTitle = '创建应收款单'
      _this.dialogAddVisible = !_this.dialogAddVisible
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
